import { render } from "./fotito2_ingles.vue?vue&type=template&id=4d549afb&scoped=true"
import script from "./fotito2_ingles.vue?vue&type=script&lang=js"
export * from "./fotito2_ingles.vue?vue&type=script&lang=js"

import "./fotito2_ingles.vue?vue&type=style&index=0&id=4d549afb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d549afb"]])

export default __exports__